import Config from "@kaspernj/api-maker/src/config"
import I18nOnSteroids from "i18n-on-steroids"
import RaiseInBackground from "i18n-on-steroids/src/error-handlers/raise-in-background"

const apiMakerFiles = require.context("../../../config/locales/api_maker", true, /^.\/([a-z.]+)\.yml$/)
const dateTimeFiles = require.context("../../../config/locales/awesome_translations/date_time", true, /^(.+)\.yml$/)
const hayaSelectFiles = require.context("../../../config/locales/haya_select", true, /^(.+)\.yml$/)
const i18n = new I18nOnSteroids({
  fallbacks: {
    da: ["da", "en", "no", "se"],
    en: ["en", "da", "se", "no"],
    no: ["no", "en", "da", "se"],
    se: ["se", "en", "no", "da"]
  }
})
const jsFiles = require.context("../../../config/locales/js", true, /^(.+)\.yml$/)
const awesomeTranslationsJsFiles = require.context("../../../config/locales/awesome_translations/js", true, /^(.+)\.yml$/)
const modelFiles = require.context("../../../config/locales/awesome_translations/models", true, /^(.+)\.yml$/)
const numbersFiles = require.context("../../../config/locales/awesome_translations/numbers", true, /^(.+)\.yml$/)
const routetTranslatorFiles = require.context("../../../config/locales/route_translator", true, /^(.+)\.yml$/)

i18n.scanRequireContext(apiMakerFiles)
i18n.scanRequireContext(awesomeTranslationsJsFiles)
i18n.scanRequireContext(dateTimeFiles)
i18n.scanRequireContext(hayaSelectFiles)
i18n.scanRequireContext(jsFiles)
i18n.scanRequireContext(modelFiles)
i18n.scanRequireContext(numbersFiles)
i18n.scanRequireContext(routetTranslatorFiles)

const locale = document.querySelector("html").getAttribute("lang")

i18n.setLocale(locale)
i18n.setLocaleOnStrftime()

if (window.RAILS_ENV == "production") {
  i18n.setErrorHandler(new RaiseInBackground())
}

Config.setI18n(i18n)

export default i18n
